import { render, staticRenderFns } from "./TraineeInfo.vue?vue&type=template&id=4f7065f8&scoped=true"
import script from "./TraineeInfo.vue?vue&type=script&lang=js"
export * from "./TraineeInfo.vue?vue&type=script&lang=js"
import style0 from "./TraineeInfo.vue?vue&type=style&index=0&id=4f7065f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f7065f8",
  null
  
)

export default component.exports